export const PAGE_SIZE = 100;
export const MAX_CHARS = 18000;
export const CHUNK_SIZE = 5000;
export const CHUNK_OVERLAP = 100;
